import useContextStore from '@/stores/context'
import * as Sentry from '@sentry/vue'
/**
 * @description Logger class
 * This is responsible for logging of all kind of stuff in the application
 * Default, we are using the console api for logging and this provides the basic level of logging such as
 * you can use the available method of console in developement but in production these will be replaced with empty methods
 * This can be extended with the help of adding Log level functionality
 */
class AppLogger {
  log: () => void = () => console.log.bind(console)
  debug: () => void = () => console.debug.bind(console)
  info: () => void = () => console.info.bind(console)
  warn: () => void = () => console.warn.bind(console)
  error: () => void = () => console.error.bind(console)
  logToServer: ({ err, vm, info }: any) => void = console.error.bind(console)
  /**
   * @constructor AppLogger
   */
  constructor() {
    /** Initializing the configuration of logger */
    this.initLogger()
  }

  /**
   * @description Initializing the configuration such as if environment is production then all log method will be replaced with empty methods
   * except logToServer, which will be responsible for logging the important stuff on server
   */
  initLogger() {
    /** Checking the environment */
    if (import.meta.env.MODE === 'production') {
      this.log = this.debug = this.info = this.warn = this.error = () => ({})

      this.logToServer = ({ err, _vm, _info }) => {

        const { _accountsToken, _userId, ...context }: any = useContextStore()

        const extras = {
          currency: context.currency,
          isoCode: context.isoCode,
          isoLang: context.isoLang,
          prestaShopControllerClassName: context.prestaShopControllerClassName,
          shopUrl: context.shopUrl,
          shopVersion: context.shopVersion,
        }

        Sentry.withScope((scope: Sentry.Scope) => {
          Object.entries(extras).forEach(([extra, value]) => {
            if (typeof value !== 'function')
              scope.setExtra(`context_${extra}`, value)
          })
          Sentry.captureException(err)
        })
      }
    }
  }
}

/** Creating the instance of logger */
const logger = new AppLogger()

export { logger }
